export const WORKFLOW_REPORT_COLUMNS = [
    {
        columnCode: "executionStart",
        datasource: [],
        editable: false,
        hidden: false,
        id: "JUgC",
        index: 0,
        name: "Start Date",
        options: null,
        required: true,
        systemField: true,
        type: "text",
        uiVisible: true,
        width: 115,
        key: 'executionStart'
    },
    {
        columnCode: "executionEnd",
        datasource: [],
        editable: false,
        hidden: false,
        id: "JUgD",
        index: 1,
        name: "End Date",
        options: null,
        required: true,
        systemField: true,
        type: "text",
        uiVisible: true,
        width: 115,
        key: 'executionEnd'
    },
    {
        columnCode: "executionTime",
        datasource: [],
        editable: false,
        hidden: false,
        id: "JUgE",
        index: 2,
        name: "Time Taken",
        options: null,
        required: true,
        systemField: false,
        type: "text",
        uiVisible: true,
        width: 115,
        key: 'executionTime'
    }
];
